var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadLast } from "framework/state/loader";
import { NoEntityError } from "framework/validation/validatableentity";
import { updateByCollectionResponse } from "framework/state/collection";
import { apiGetEventOfficials } from "public_app/events/endpoint";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadOfficials = function (eventId) { return function (store) {
    var loader = function () { return apiGetEventOfficials(eventId, null); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft, response);
        });
    };
    loadLast(store, loader, stateProducer);
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadOfficials: loadOfficials,
    },
    name: "EventCalendarOfficials"
});
var useState = createHook(store);
export { useState as useEventCalendarOfficials, };
